"use client";

import { useEffect } from "react";
import { Link } from "@tanstack/react-router";
import * as Sentry from "@sentry/react";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="mx-auto flex min-h-dvh max-w-2xl flex-col items-center justify-center px-6 text-center">
      <h1 className="text-3xl font-semibold text-sky-600">
        Something went wrong
      </h1>
      <p className="mt-4 text-base text-gray-700">
        An unexpected error occurred while rendering this page.
      </p>
      <Link
        to="/"
        className="mt-6 rounded-md bg-sky-600 px-4 py-2 text-white no-underline hover:bg-sky-700"
      >
        Return Home
      </Link>
    </div>
  );
}
